module.exports = __webpack_public_path__ + "img/advantagesImg2.92db8aae.jpg";